import { OpenhousePostProps } from "../../../listings/listing/types";
import CustomPosts from "../CustomPosts";

export default function OpenHousePost({
    setIsOpen,
    listing,
    open,
}: OpenhousePostProps) {
    return (
        <CustomPosts
            setIsOpen={setIsOpen}
            listing={listing}
            open={open}
            isOpenHouse={true}
        />
    );
}
